// import React, { useEffect, useState } from "react";
// import "../ProductCategory/productCategory.scss";
// import Form from "react-bootstrap/Form";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../../components/Token";
// import CancelButton from "../../../../components/MinorComponents/CancelButton";
// import { POSTVendorsubcategory } from "../../../../services/api/Subcategory";
// import { GetVendorCategory } from "../../../../services/api/Category";

// function SubProductVendorCategory() {
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [subCategoryName, setSubCategoryName] = useState("");
//   const [isSuccess, setIsSuccess] = useState(false);
//   const subdomain = localStorage.getItem("vendorsubdomain")
//   const navigate = useNavigate();
//   const headers = useAuthHeaders();

//   useEffect(() => {

//     const fetchHandler = async () => {

//       const response = await GetVendorCategory(subdomain)
//       if (response.success) {
//         setCategories(response?.categories);
//       }

//     }
//     fetchHandler()
//   }, []);

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     const payload = {
//       name: subCategoryName,
//       categoryId: selectedCategory,
//     }
//     const response = POSTVendorsubcategory(subdomain, payload)
//     if (response.success) {

//     }
//   };

//   return (
//     <div className="p-4">
//       <h2>Sub Category</h2>
//       <form onSubmit={handleFormSubmit} className="category" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <div className="row category-field">
//           <div className="col-md-6">
//             <label htmlFor="name" className="fs-6">
//               Category Name:
//             </label>
//             <br />
//             <Form.Select
//               aria-label="Default select example"
//               className="my-2"
//               value={selectedCategory}
//               onChange={(e) => setSelectedCategory(e.target?.value)}
//               required
//             >
//               <option value="">Select a category</option>
//               {categories.map((category) => (
//                 // console.log(category,"category") 
//                 <option key={category?._id} value={category?.name}>
//                   {category?.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </div>

//           <div className="col-md-6">
//             <label htmlFor="name" className="fs-6">
//               Sub Category Name:
//             </label>
//             <br />
//             <input
//               type="text"
//               id="name"
//               value={subCategoryName}
//               onChange={(e) => setSubCategoryName(e.target?.value)}
//             />
//           </div>
//         </div>
//         <div className="buttons">
//           <button style={{ backgroundColor: "#0443C0", color: "white" }}>Save</button>
//           <CancelButton path="/subCategory" />
//         </div>
//       </form>
//       {isSuccess && (
//         <p className="text-danger">Sub category added successfully!</p>
//       )}
//     </div>
//   );
// }

// export default SubProductVendorCategory;
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
  Alert,
  InputLabel,
  FormControl,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../../utils/index";
import { useAuthHeaders } from "../../../../components/Token";
import CancelButton from "../../../../components/MinorComponents/CancelButton";
import { POSTVendorsubcategory } from "../../../../services/api/Subcategory";
import { GetVendorCategory } from "../../../../services/api/Category";

function SubProductVendorCategory() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [subCategoryName, setSubCategoryName] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const subdomain = localStorage.getItem("vendorsubdomain");
  const navigate = useNavigate();
  const headers = useAuthHeaders();

  useEffect(() => {
    const fetchCategories = async () => {
      const response = await GetVendorCategory(subdomain);
      if (response.success) {
        setCategories(response?.categories);
      } else {
        setSnackbar({
          open: true,
          message: "Failed to load categories",
          severity: "error",
        });
      }
    };

    fetchCategories();
  }, [subdomain]);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      name: subCategoryName,
      categoryId: selectedCategory,
    };

    try {
      const response = await POSTVendorsubcategory(subdomain, payload);
      console.log(response, "response")
      if (response.success) {
        setSnackbar({
          open: true,
          message: response.message,
          severity: "success",
        });
        navigate(`/${subdomain}/master/sub-category/`)
        setSelectedCategory("");
        setSubCategoryName("");
      } else {
        setSnackbar({
          open: true,
          message: response.data.message,
          severity: "error",
        });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.data.error,
        severity: "error",
      });
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Create Sub Category
      </Typography>

      <Paper elevation={1} sx={{ p: 3, maxWidth: 700 }}>
        <form onSubmit={handleFormSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth required size="small">
                <InputLabel>Category Name</InputLabel>
                <Select

                  value={selectedCategory}
                  label="Category Name"
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <MenuItem value="">Select a category</MenuItem>
                  {categories.map((category) => (
                    <MenuItem key={category._id} value={category._id}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="Sub Category Name"
                value={subCategoryName}
                onChange={(e) => setSubCategoryName(e.target.value)}
                required
              />
            </Grid>
          </Grid>

          <Box display="flex" gap={2} mt={3}>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
            <Button type="submit" variant="contained" color="error" onClick={() => navigate(`/${subdomain}/master/sub-category/`)}>
              Close
            </Button>

          </Box>
        </form>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default SubProductVendorCategory;
